import React from "react";
import moment from "moment";

const RecentHistory = (props) => {
  return (
    <>
      {props.Billing.length !== 0 ? (
        props.Billing.map((data) => {
          return (
            <>
              <div className="member__history">
                <h2 className="text-jost-sb-24">Recent History:</h2>

                <div className="member__history-table">
                  <div className="table_head">
                    <span className="table__row-0">Invoice Number</span>
                    <span className="table__row-0">Invoice Date</span>
                    <span className="table__row-0">Amount</span>

                    <span className="table__row-0">PDF</span>
                  </div>
                  {data.map((user) => {
                    return (
                      <div className="table_detail">
                        <span>{user.id}</span>
                        <span>
                          {moment(user.start_date).format("DD/MM/YY")}
                        </span>
                        <span>
                          £
                          {(
                            user.total_amt ||
                            user.subscription_mapping.subscription.amount
                          ).toFixed(2)}
                        </span>
                        <span>
                          {" "}
                          <a
                            href={user.invoice_file_url}
                            target="_blank"
                            className="res-btn-primary btn_important "
                            download
                          >
                            download
                          </a>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          );
        })
      ) : (
        <div className="member__history">
          <h2 className="text-jost-sb-24">Recent History:</h2>

          <div className="member__history-table">
            <div className="table_head">
              <span className="table__row-0">Invoice Number</span>
              <span className="table__row-0">Invoice Date</span>
              <span className="table__row-0">Amount</span>

              <span className="table__row-0">PDF</span>
            </div>
            <div className="table_detail">
              <span></span>
              <span></span>
              <span></span>
              <span>
                {" "}
                <a
                  href="/blak"
                  target="_blank"
                  className="res-btn-primary"
                  download
                >
                  download
                </a>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RecentHistory;
